import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/2/thumb-landscape.jpg"

const Post2 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">J&M DAVIDSON／カーニバルM／17 x21 x17cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          おしゃれは季節を先取りすることから！秋は短いシーズンだからこそ、トレンドを取り入れて旬なオシャレを楽しんでみませんか？今回は、ラクサスで人気のブランドバッグをおすすめの秋コーデとともにご紹介します♪
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ジェイアンドエムデヴィッドソン(J&M DAVIDSON)／カーニバルL</h2>
          <p>タートルとタイトスカートを合わせたフェミニンコーデは、全体をベージュトーンで統一することで大人っぽく仕上がります。フリンジがポイントの「カーニバル」はアクセサリー感覚で取り入れたいバッグ。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/2/1.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/2/2.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/2/3.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">20x24x20cm(幅x高さxマチ)</span>        
        <Link to="https://laxus.co/app/pc/bags/jandmdavidson" className="view-all-button">
          J&M DAVIDSONのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>ディオール(Dior)／ブックトート</h2>
          <p>ベーシックなワンピースはワンショルダーで今っぽくアップデート。「ブックトート」でコーデに華やかなアクセントをプラス。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/2/4.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/2/5.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/2/6.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">42x35x16cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/jandmdavidson" className="view-all-button">
          ディオールのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>ボッテガ・ヴェネタ(BOTTEGA VENETA)／ミニ ザ・ポーチ</h2>
          <p>いつものTシャツ×デニムコーデも「ザ・ポーチ」を合わせることでワンランク上の大人カジュアルにアップデート。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/2/7.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
          <StaticImage src="../../images/posts/2/8.jpg" alt="" />
          </figure>
          <figure className="img-small">
          <StaticImage src="../../images/posts/2/9.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">22x14x5cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/jandmdavidson" className="view-all-button">
          ボッテガ・ヴェネタのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>ロエベ(LOEWE)／アマソナ28</h2>
          <p>ゆったりとしたシルエットのシャツにはテーパードパンツを合わせるとコーデが締まります。ロエベの「アマソナ」でコーデをさらにスタイリッシュに。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/2/10.jpg" alt="" />
        </figure>
        <div className="img-two-cloumn">
            <figure className="img-small">
            <StaticImage src="../../images/posts/2/11.jpg" alt="" />
            </figure>
            <figure className="img-small">
            <StaticImage src="../../images/posts/2/12.jpg" alt="" />
            </figure>
        </div>
        <span className="text-center">32x28.5x15.5cm(幅x高さxマチ)</span>
        <Link to="https://laxus.co/app/pc/bags/jandmdavidson" className="view-all-button">
          ロエベのバッグを見る
        </Link>                  
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post2

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 2}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
